import React, { PropTypes } from 'react'
import InputField from 'components/InputField/InputField';
import SelectField from 'components/InputField/SelectField';
import CountyInput from 'containers/Input/CountyInput';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { FormControlLabel } from 'material-ui/Form';

const labels = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  user_type: 'I am a',
  imc: 'GMC Number',
  registration: 'Registration Number',
  practice_name: 'Practice Name',
  phone: 'Phone',
  hospital: 'Hospital',
  title: 'Title'
}

const roles = [
  { value: 'gp', label: 'GP' },
  { value: 'gp_trainee', label: 'GP Trainee' },
  { value: 'practice_nurse', label: 'Practice Nurse' },
  { value: 'consultant', label: 'Consultant' },
  { value: 'hospital_doctor', label: 'NCHD (Hospital Doctor)' },
  { value: 'nurse_specialist', label: 'Nurse specialist' }
]

const titles = [
  { label: 'Dr.', value: 'dr' },
  { label: 'Mr.', value: 'mr' },
  { label: 'Ms.', value: 'ms' },
  { label: 'Mrs.', value: 'mrs' },
  { label: 'Prof.', value: 'prof' }
];

const hideMore = (user, onCountyChange) => {
  if (user.user_type && (['consultant', 'hospital_doctor', 'sponsor'].indexOf(user.user_type) > 0)) {
    if (user.county) {
      onCountyChange({target: {value: ''}});
    }
    return true
  } else {
    return false
  }
}

const Profile = ({
  user,
  user: {
    first_name,
    last_name,
    email,
    user_type,
    country,
    county,
    phone,
    title,
    notification_enabled,
    email_confirmed,
    company_name,
  },

  errors,
  onFieldChange,
  onSubmit,
  onRoleChange,
  roleFields,
  onCountyChange,
  is_admin
}) => {
  const hideMoreValue = hideMore(user, onCountyChange);
  return (
  <div className="container_form">
    <div className="section_form row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          <SelectField
            className='col s12'
            label={labels['title']}
            onChange={onFieldChange}
            errors={errors['title']}
            autoComplete='new-password'
            field_name='title'
            value={title}
            options={titles}
          />
          {
            [{
                field_name: 'first_name',
                value: first_name,
                className: 'col s12 m6'
              }, {
                field_name: 'last_name',
                value: last_name,
                className: 'col s12 m6'
              }, {
                field_name: 'email',
                value: email,
                type: 'email',
                className: 'col s12'
            }].map(e => (
              <InputField
                className='col s12'
                label={labels[e.field_name]}
                onChange={onFieldChange}
                errors={errors[e.field_name]}
                autoComplete='new-password'
                {...e}
              />
            ))
          }

          {
            ['sponsor'].indexOf(user.user_type) === -1 &&
            <SelectField
              className='col s12'
              label={labels['user_type']}
              onChange={onRoleChange}
              errors={errors['user_type']}
              autoComplete='new-password'
              field_name='user_type'
              value={user_type || ''}
              options={roles}
            />
          }
          {
            roleFields.map(field => (
              <InputField
                className='col s12'
                label={labels[field]}
                onChange={onFieldChange}
                errors={errors[field]}
                autoComplete='new-password'
                value={user[field]}
               field_name={field}
              />
            ))
          }
          { user.user_type === 'sponsor' &&
            <InputField
              className='col s12'
              label='Company'
              onChange={onFieldChange}
              errors={errors['company_name']}
              autoComplete='new-password'
              value={user.company_name}
              field_name={'company_name'}
            />
          }

          {hideMoreValue ? null :
            <div>
              <CountyInput
                value={county}
                onChange={onCountyChange}
                errors={errors['county']}
              />
            </div>
          }

          <InputField
            className='col s12'
            label={labels['phone']}
            onChange={onFieldChange}
            errors={errors['phone']}
            autoComplete='new-password'
            value={phone}
           field_name={'phone'}
          />
          { !is_admin &&
            <div className="col s12 email_notification">
              <FormControlLabel
                control={
                <Checkbox
                  checked={notification_enabled}
                  name='notification_enabled'
                  onChange={() => onFieldChange({ target: {
                    name: 'notification_enabled', value: !notification_enabled
                  }})}
                />
               }
               label={<span className="email_notification_label">
                        <span>Send webinar reminders via email</span>
                        <span>
                          You won't receive email reminders 1 hour and 24 hours before the webinar starts if you uncheck this box.
                        </span>
                      </span>}
             />
            </div>
          }
          { is_admin &&
            <div className="col s12 email_notification">
              <FormControlLabel
                control={
                <Checkbox
                  checked={email_confirmed}
                  name='notification_enabled'
                  onChange={() => onFieldChange({ target: {
                    name: 'email_confirmed', value: !email_confirmed
                  }})}
                />
               }
               label={<span className="email_notification_label">
                        <span>Email confirmed</span>
                        <span>

                        </span>
                      </span>}
             />
            </div>
          }

          <div className="submit_center col s12">
            <input className="sign" type="submit" name="" value="Update" />
            <label></label>
          </div>
          { !is_admin &&
            <div className="submit_center col s12" style={{ marginTop: '15px'}}>
              <a href="#change_password">&nbsp;Change Password</a>
            </div>
          }

        </div>
      </form>
    </div>
  </div>
)}

Profile.propTypes = {
  user: PropTypes.object,
  errors: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onRoleChange: PropTypes.func,
  roleFields: PropTypes.array,
}

export default Profile



/** WEBPACK FOOTER **
 ** ./src/components/Profile/Profile.js
 **/